

import Flashcards from './Flashcards.js';

import './App.css';

function App() {
  return (
    <div className='App'>
      <Flashcards/>
    </div>
  );
}

export default App;
